import { IUserBaseInfo } from "./userBaseInfo";
import { IStudentInfo } from './studentInfo';
import { IEnterpriseInfo } from './enterpriseInfo';
/**
 * @desc 开关状态
 */
export enum SWITCH_STATUS {
    NO = 0,
    YES = 1,
}
export interface IKnowledgePointConfig {
    is_admin: SWITCH_STATUS;
    is_enable_knowledge_point: SWITCH_STATUS;
    is_show_department_knowledge_point: SWITCH_STATUS;
    knowledge_point_update_time: string;
    manage_top_department_id: string;
}
export interface IUserInfo extends IUserBaseInfo {
    achievement_url: string;
    email: string;
    enterprise_info: IEnterpriseInfo;
    person_home_url: string;
    phone: string;
    phone_number: string;
    remark: string;
    student_id: string;
    login_name: string;
    student_info: IStudentInfo;
    teacher_id: string;
    teacher_info?: {
        teacher_status: number
    }
}
